import React from 'react';
import classNames from 'classnames';
import Typography from 'src/components/common/typography/Typography';
import Card from 'src/components/common/card/Card';
import './CreateCompanyNowCard.scss';
import Button from 'src/components/button/Button';
import { useNavigate } from 'react-router-dom';

function CreateCompanyNowCard() {
    // Hooks
    const navigate = useNavigate();

    const redirectToCreateCompany = () => {
        navigate('/create-company');
    };
    return (
        <Card className={classNames('CreateCompanyNowCard')}>
            <Typography as="p" variant="body-1" fontWeight="semiBold">
                Create Your Company Page Now!
            </Typography>{' '}
            <Typography as="p" variant="body-3" fontWeight="regular">
                Launch your brand online - create your company page now!
            </Typography>
            <div className='svgBox'>
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="33" viewBox="0 0 31 33" fill="none">
                        <path d="M15.626 20.6804V17.0804M15.626 20.6804V24.2804M15.626 20.6804H26.426C28.4142 20.6804 30.026 19.0687 30.026 17.0804M15.626 20.6804H4.82595C2.83773 20.6804 1.22595 19.0687 1.22595 17.0804M30.026 17.0804V27.8804C30.026 29.8687 28.4142 31.4804 26.426 31.4804H4.82595C2.83773 31.4804 1.22595 29.8687 1.22595 27.8804V17.0804M30.026 17.0804V9.88043C30.026 7.89221 28.4142 6.28043 26.426 6.28043H4.82595C2.83773 6.28043 1.22595 7.89221 1.22595 9.88043V17.0804M21.026 6.28043V4.48043C21.026 2.49221 19.4142 0.880432 17.426 0.880432H13.826C11.8377 0.880432 10.226 2.49221 10.226 4.48043V6.28043" stroke="white" strokeWidth="1.62" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </span>
            </div>
            <Button size="small" variant="secondary" onClick={redirectToCreateCompany}>
                Get Started
            </Button>

        </Card>
    )
}

export default CreateCompanyNowCard
